var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -10,
    y: -9.5,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_3055_9656_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 70,
    height: 70,
    rx: 17.5,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 40.168C37.9467 40.168 40.3334 37.7813 40.3334 34.8346V27.5013C40.3334 24.5546 37.9467 22.168 35.0001 22.168C32.0534 22.168 29.6667 24.5546 29.6667 27.5013V34.8346C29.6667 37.7813 32.0534 40.168 35.0001 40.168Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 32.3672V34.6339C24.8 40.2605 29.3734 44.8339 35 44.8339C40.6267 44.8339 45.2 40.2605 45.2 34.6339V32.3672",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1467 28.0722C34.3467 27.6322 35.6534 27.6322 36.8534 28.0722",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 30.9017C34.64 30.7151 35.3734 30.7151 36.08 30.9017",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 44.832V48.832",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3055_9656_clip_path",
    transform: "translate(10 9.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 70,
    height: 70,
    rx: 17.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaMic);
export default __webpack_public_path__ + "static/media/aa-mic.f052aeb944d405c0545e82a46851a70a.svg";
export { ForwardRef as ReactComponent };